import { Dates } from "@salaxy/core";
/**
 * Formats date (default format DD.MM.YYYY)
 * @param start A dately value as the start date
 * @param options Parameters for format and end
 * @returns Formatted as in DD.MM.YYYY format or provided format
 */
export function hbsHelperD(start: string | number, options: any): string  {
  const params = options && options.hash ? options.hash : options;
  return (params && params.end) ? Dates.getFormattedRange(start, params.end) : start ? params.format ? Dates.format(start, params.format) : Dates.format(start) : "-";
}